import EditPartnerBranchForm from './editPartnerBranchForm';

const EditPartnerBranch = () => {
    return (
        <div className='create-merchant'>
            <EditPartnerBranchForm />
        </div>
    );
};

export default EditPartnerBranch;
